import {AdShareByEmailUserError} from './AdShareByEmailUserError.js'
import {CheckGigyaUserExistsUserError} from './CheckGigyaUserExistsUserError.js'
import {CheckUserEmailExistsUserError} from './CheckUserEmailExistsUserError.js'
import {GenericUserError} from './GenericUserError.js'
import {GetContactTokenUserError} from './GetContactTokenUserError.js'
import {GetConversationUserError} from './GetConversationUserError.js'
import {LeadHitUserError} from './LeadHitUserError.js'
import {SaveAdShareByEmailHitUserError} from './SaveAdShareByEmailHitUserError.js'
import {SaveContactTokenUserError} from './SaveContactTokenUserError.js'
import SendEmailToVerifyUserError from './SendEmailToVerifyUserError.js'
import {SubscriptionsUserError} from './SubscriptionsUserError.js'
import UserNotLoggedInUserError from './UserNotLoggedInUserError.js'
import {ValidatePhoneVerificationCodeUserError} from './ValidatePhoneVerificationCodeUserError.js'

export class UserErrorsFactory {
  static genericUserError = message => new GenericUserError(message)

  static adShareByEmailUserError = msg => new AdShareByEmailUserError(msg)

  static getContactTokenUserError = () => new GetContactTokenUserError()

  static leadHitUserError = msg => new LeadHitUserError(msg)

  static saveAdShareByEmailHitUserError = msg => new SaveAdShareByEmailHitUserError(msg)

  static saveContactTokenUserError = () => new SaveContactTokenUserError()

  static userNotLoggedInUserError = ({message}) => new UserNotLoggedInUserError({message})

  static checkGigyaUserExistsUserError = ({message}) => new CheckGigyaUserExistsUserError({message})

  static checkUserEmailExistsUserError = ({message}) => new CheckUserEmailExistsUserError({message})

  static getConversationUserError = message => {
    return new GetConversationUserError(message)
  }

  static sendEmailToVerifyUserError = message => new SendEmailToVerifyUserError(message)

  static subscriptionsUserError = message => new SubscriptionsUserError(message)

  static validatePhoneVerificationCodeUserError = ({code, remainingAttempts = 3} = {}) =>
    new ValidatePhoneVerificationCodeUserError(JSON.stringify({code, remainingAttempts}))
}
